import StringMask from 'string-mask';

export default (value, previousValue) => {

  if (!value)
    return value;

  const onlyNums = value.replace(/[^\d]/g, '').toString();

  const formatter = new StringMask('00:00');
  return formatter.apply(onlyNums);


};



// WEBPACK FOOTER //
// ./src/components/normalize/HourMinuteNormalize.js